<mat-dropdown
  [formControl]="formControl()"
  [options]="dropdownOptions()"
  [configurationInput]="dropdownConfiguration()"
  [isFormSubmitted]="isFormSubmitted()"
  [isLoading]="areOptionsLoading()"
></mat-dropdown>
